{
  "version": 1,
  "asset_id": "ec8d7d9c-9982-4497-af89-31ac62790239",
  "project_id": "8d7278d8-f7c2-487a-a967-889b9bac3b6c",
  "url": "/__l5e/assets-v1/ec8d7d9c-9982-4497-af89-31ac62790239/lineup-4-machines.png",
  "r2_key": "a/v1/8d7278d8-f7c2-487a-a967-889b9bac3b6c/ec8d7d9c-9982-4497-af89-31ac62790239/lineup-4-machines.png",
  "original_filename": "lineup-4-machines.png",
  "size": 456903,
  "content_type": "image/png",
  "created_at": "2026-07-03T06:45:56Z"
}
